import React,{ useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

import {TextInput} from '../../components/TextInput/index.js';
import {SubmitButton} from '../../components/SubmitButton/index.js';
import store from '../../store'
import authSlice from '../../slices/authSlice'

import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"

export const AccountantLogin = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState(null);
  const [error,setError] = useState('');
  const [loading,setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(()=>{
    
  },[]);

  const onSubmit = useCallback(
    async(e) => {
      e.preventDefault();

      const res = await store.dispatch(authSlice.async$.attemptAccountantLogin({email, password}))

    },
    [email, password]
  )



  return (
    <EmojiProvider data={emojiData}>
    <div className="global-container">
        <div className={styles.loginLogoContainer}>
          <img src={require('../../images/logo.png')} className={styles.loginLogo} />
          <div className={styles.loginLogoText}>SimplyNomad</div>
          <br/>
          <div className={styles.subtitle}>
            Note: For Clients Logging-In, Please Visit The Client Login Page.
          </div>
        </div>
        <div className="global-login-card-view" id={styles.loginPanel}>
          <div id={styles.loginHeaderMain}>Accountant Login</div>
          <br/>
          <TextInput placeholder={'Email'} type={'email'} onChange={(value)=>{setEmail(value)}} />
          <TextInput placeholder={'Password'} type={'password'} onChange={(value)=>{setPassword(value)}} />

          <SubmitButton loading={loading} title={'Accountant Log In'} emoji={<Emoji name="rocket" className="emoji" width={22} />} onClick={onSubmit} />

          <div className={styles.loginError}>{error}</div>
          <br/>
          <div id={styles.loginLinks}>
            <a className={styles.loginLink} href="./signup">Sign Up </a> |
            <a className={styles.loginLink} href="./forgot-password"> Forgot Your Password?</a> |
            <a className={styles.loginLink} href="./login"> Client Login</a>
          </div>
        </div>

        <div className={styles.loginCopyright}>

          	&copy; Copyright Conquer Technologies Ltd. 2024
        </div>
    </div>
    </EmojiProvider>
  )
}